import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register(
  'admin-polymorphic-select',
  class extends Controller {

    static targets = ['typeField', 'idSelect']

    connect() {
      this.#idSelectAsSelect2().on('select2:select', (event) => this.#updateType(event))
    }

    #updateType(event) {
      this.typeFieldTarget.value = event.params.data.element.dataset.modelName
    }

    #idSelectAsSelect2() {
      return $(this.idSelectTarget)
    }
  }
)
